<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgemtn" style="padding-top:150px">
<p style="text-indent:0em">The start of this story spans a varied measure of time.</p>
<p style="text-indent:0em">The date is between 950 and 929 BC.</p>
<p style="text-indent:0em">In the reign of Pharaoh H.Amon (Eldesty)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?ae0da5e4